export default __webpack_public_path__ + "static/media/map-pacific.f955baab.jpg";